export const EMPLOYER_EMAIL_MAX_LENGTH = 64;

export const EMPLOYER_FIRST_OR_LAST_NAME_MAX_LENGTH = 32;
